import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const ModuleContentSettings = styled.div`
    margin: 0 24px;
`;

export const SettingsTableSeparator = styled.div`
    position: sticky;
    top: 0;
    z-index: 110;
    width: 100%;
    min-height: 27px;
    background-color: ${owcTheme['one-color-background-intensity-lower']};
`;
